export function safeJSONParse(json: string): any {
  try {
    const res = JSON.parse(json);

    return res;
  } catch {
    return '';
  }
}
